import { TextButton } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { MobileStatusBox } from './MobileStatusBox';
export const MobilePrimaryDomainNotRegistered = _ref => {
  let {
    domainName,
    action,
    datahook
  } = _ref;
  const {
    Trans
  } = DomainSearchGateModule.internals.useTranslations();
  const parsedDomain = parseDomain(domainName ?? '');
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.mobile.error.subdomain",
    values: {
      domainName: parsedDomain.main
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: action
    })]
  }));
};
//# sourceMappingURL=MobilePrimaryDomainNotRegistered.js.map